import * as XLSX from "xlsx";

import {
  CLASE_OPTIONS,
  REPORTE_OPTIONS,
  SUB_CLASE_2_OPTIONS,
  SUB_CLASE_OPTIONS,
  TIPO_OPTIONS,
} from "~/types/contabilidad";

/**
 * Generate and download an Excel template for account mapping import
 */
export function downloadMappingTemplate(templateName?: string): void {
  // Create workbook
  const wb = XLSX.utils.book_new();

  // Create the main data sheet with headers
  const headers = [
    "Codigo",
    "Cuenta",
    "Tipo",
    "Reporte",
    "Clase",
    "Orden Clase",
    "Orden Tipo",
    "Sub Clase",
    "Orden Subclase",
    "SubClase 2",
    "Orden Subclase 2",
    "Grupo Cuenta",
    "Orden grupo cta.",
    "Clave",
    "Signo",
    "Clase 1",
  ];

  // Example data row
  const exampleRow = [
    "1101001", // Codigo
    "CAJA", // Cuenta
    "Activo", // Tipo
    "Balance", // Reporte
    "Activo", // Clase
    1, // Orden Clase
    1, // Orden Tipo
    "Activo", // Sub Clase
    1, // Orden Subclase
    "Activo Corriente", // SubClase 2
    1, // Orden Subclase 2
    "1101", // Grupo Cuenta
    1, // Orden grupo cta.
    1, // Clave
    "", // Signo (empty or -1)
    "", // Clase 1
  ];

  const dataSheet = XLSX.utils.aoa_to_sheet([headers, exampleRow]);

  // Set column widths
  dataSheet["!cols"] = [
    { wch: 12 }, // Codigo
    { wch: 30 }, // Cuenta
    { wch: 10 }, // Tipo
    { wch: 12 }, // Reporte
    { wch: 18 }, // Clase
    { wch: 12 }, // Orden Clase
    { wch: 12 }, // Orden Tipo
    { wch: 25 }, // Sub Clase
    { wch: 14 }, // Orden Subclase
    { wch: 30 }, // SubClase 2
    { wch: 16 }, // Orden Subclase 2
    { wch: 15 }, // Grupo Cuenta
    { wch: 14 }, // Orden grupo cta.
    { wch: 8 }, // Clave
    { wch: 8 }, // Signo
    { wch: 15 }, // Clase 1
  ];

  XLSX.utils.book_append_sheet(wb, dataSheet, "Mapeo");

  // Create reference sheet with valid values
  const referenceData = [
    ["Valores de Referencia"],
    [],
    ["Tipo (valores sugeridos):"],
    ...TIPO_OPTIONS.map((v) => ["  - " + v]),
    [],
    ["Reporte (valores válidos):"],
    ...REPORTE_OPTIONS.map((v) => ["  - " + v]),
    [],
    ["Clase (valores válidos):"],
    ...CLASE_OPTIONS.map((v) => ["  - " + v]),
    [],
    ["Sub Clase (valores sugeridos):"],
    ...SUB_CLASE_OPTIONS.map((v) => ["  - " + v]),
    [],
    ["SubClase 2 (valores sugeridos):"],
    ...SUB_CLASE_2_OPTIONS.map((v) => ["  - " + v]),
    [],
    ["Signo:"],
    ["  - (vacío) = sin signo"],
    ["  - -1 = signo negativo"],
    [],
    ["Notas:"],
    ["  - Los códigos de cuenta deben existir en la empresa"],
    ["  - Reporte y Clase son estrictos, use los valores indicados"],
    ["  - Tipo, Sub Clase, SubClase 2, Grupo Cuenta, y Clase 1 permiten valores personalizados"],
    ["  - Grupo Cuenta debe coincidir con el código del grupo en el sistema"],
  ];

  const refSheet = XLSX.utils.aoa_to_sheet(referenceData);
  refSheet["!cols"] = [{ wch: 60 }];
  XLSX.utils.book_append_sheet(wb, refSheet, "Referencia");

  // Generate filename
  const timestamp = new Date().toISOString().slice(0, 10);
  const filename = templateName
    ? `mapeo_${templateName.replace(/[^a-zA-Z0-9]/g, "_")}_${timestamp}.xlsx`
    : `mapeo_template_${timestamp}.xlsx`;

  // Download
  XLSX.writeFile(wb, filename);
}
